import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { ThemeProvider } from 'react-css-themr';
import Card from 'components/Card';
import { ResourceDetailsCardElement } from 'components/ResourceCardElements';
import sectionTheme from 'styles/detailsSection.scss';
import detailsCardElement from 'styles/detailsCardElement.scss';
import cx from 'classnames';
import CrewListingSection from './crewListingSection';
import helperCardStyle from './helperCard.scss';
import { roleNotInstallerBased } from '../../../../../utils';
import { isOverdue } from '../../../../../utils/dateUtils.js';

const detailsTheme = { ResourceDetailsCE: detailsCardElement };

const sectionTitle = cx([sectionTheme.sectionTitle, sectionTheme.bigTitle]);

const parseBadgeLink = url => (/^https?:\/\//.test(url) ? url : `https://${url}`);

const InstallerCrewDetails = (props) => {
  const { helpers, crews, crewsWorkrooms, crewsSurfaceTypes, role } = props;
  const helperDivs = helpers.map((helper) => {
    const badgeDate = helper.badge_expiration.toString() || '';
    const dateObj = new Date(badgeDate);
    const dateISO = dateObj.toISOString();
    const isBadgeOverdue = isOverdue(dateISO);
    const cardStyle = cx([helperCardStyle.helperCard, {
      [helperCardStyle.doNotUse]: helper.not_used,
      [sectionTheme.inactive]: !helper.not_used && helper.disabled,
    }]);
    return (<Card key={helper.id} className={cardStyle}>
      <div className={sectionTheme.flexboxDiv}>
        <ResourceDetailsCardElement
          size="small"
          title="name"
          value={helper.name}
        />
        {roleNotInstallerBased(role) && <Fragment>
          <ResourceDetailsCardElement
            size="small"
            title="phone number"
            value={helper.phone_number}
          />
          <ResourceDetailsCardElement
            size="small"
            title="email"
            value={helper.email}
          />
        </Fragment>}
        <ResourceDetailsCardElement
          size="small"
          title="badge number"
          value={helper.badge_number}
        />
        {isBadgeOverdue ? (<ResourceDetailsCardElement
          size="small"
          title="badge expiration"
          className={helperCardStyle.overdue}
        >{badgeDate}</ResourceDetailsCardElement>) : (<ResourceDetailsCardElement
          size="small"
          title="badge expiration"
          value={badgeDate}
        />)}
        <ResourceDetailsCardElement
          size="small"
          title="badge link"
          value={helper.badge_link || 'N/A'}
        >{helper.badge_link ? (<a
          href={parseBadgeLink(helper.badge_link)} target="_blank" rel="noopener noreferrer"
        >{helper.badge_link}</a>) : 'N/A' }</ResourceDetailsCardElement>
      </div>
    </Card>);
  });

  return (
    <ThemeProvider theme={detailsTheme}>
      <div>
        <CrewListingSection
          title={'Crew Management'}
          crews={crews}
          crewsWorkrooms={crewsWorkrooms}
          crewsSurfaceTypes={crewsSurfaceTypes}
          theme={sectionTheme}
          parseBadgeLink={parseBadgeLink}
          role={role}
        />
        <section className={sectionTheme.section}>
          <div className={detailsTheme.innerSection}>
            <div className={sectionTitle}>Helpers</div>
            {helperDivs}
          </div>
        </section>
      </div>
    </ThemeProvider>
  );
};

InstallerCrewDetails.propTypes = {
  crewsSurfaceTypes: PropTypes.object,
  crewsWorkrooms: PropTypes.object,
  helpers: PropTypes.array,
  crews: PropTypes.array,
  role: PropTypes.string,
};


export default InstallerCrewDetails;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/installers/components/installerCrewDetails.jsx